import { css } from '@emotion/react';

const makeDatePickerStyling = ({ theme }) => {
  return {
    datePickerRoot: css({
      marginBottom: theme.mvf.spacing.medium,
      marginTop: theme.mvf.spacing.medium,
    }),
    datePickerBox: css({
      marginTop: theme.mvf.spacing.medium,
    }),
  };
};

export default makeDatePickerStyling;
